import { lazy } from "react";

// Route code is split per page. The dashboard (landing page after login) is bundled with the
// app shell, so the first screen needs no extra round trip. Everything else is fetched on demand
// and prefetched once the browser is idle, so navigating is instant after the first screen.
const loaders = {
  daily: () => import("../components/dailyWorkers/dailyWorkers"),
  salaries: () => import("../components/Salary report/salaryReport"),
  deductions: () => import("../components/DeductionSection/deductionSection"),
  purchases: () => import("../components/Purchase Section/PurchaseSection"),
  materials: () => import("../components/Material Section/MaterialSection"),
  reports: () => import("../components/EmployeeReports/EmployeeReportsPage"),
  reportProfile: () => import("../components/EmployeeReports/EmployeeReportProfile"),
  workTypes: () => import("../components/WorkTypes/WorkTypeRates"),
  monthly: () => import("../components/MonthlyReport/MonthlyReportPage"),
  maintenance: () => import("../components/Maintenance/MaintenancePage"),
  itemHistory: () => import("../components/Maintenance/ItemHistoryPage"),
  publicItem: () => import("../components/Maintenance/PublicItemPage"),
  food: () => import("../components/Food/FoodPage"),
  audit: () => import("../components/Audit/AuditLogPage"),
};

export const pages = Object.fromEntries(
  Object.entries(loaders).map(([key, load]) => [key, lazy(load)])
);

let prefetched = false;
export function prefetchPages() {
  if (prefetched) return;
  // Respect data-saver mode and slow connections.
  const connection = navigator.connection;
  if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || "")))
    return;
  prefetched = true;
  const run = () => Object.values(loaders).forEach((load) => load().catch(() => {}));
  if ("requestIdleCallback" in window) window.requestIdleCallback(run, { timeout: 4000 });
  else setTimeout(run, 2000);
}
